import { configureStore } from '@reduxjs/toolkit';
import { createRootReducer } from './redux/reducers/root_reducer';
const rootReducer = createRootReducer();
const store = configureStore({
    reducer: rootReducer,
    middleware: getDefaultMiddleware => {
        return getDefaultMiddleware({ serializableCheck: false });
    },
});
export default store;
